(function () {
  'use strict';

  function bindDrawer(drawer) {
    if (!drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('button, a, input');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    document.querySelectorAll('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  document.querySelectorAll('.drawer').forEach(bindDrawer);

  document.querySelectorAll('.accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });

  document.querySelectorAll('.qty').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full;
        main.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', 'false');
        });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  var picker = document.querySelector('[data-variants]');
  if (picker) {
    var variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var idInput = picker.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var addBtn = picker.querySelector('[data-add]');
    var money = picker.dataset.moneyFormat || '';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      if (!money) return '£' + amount;
      return money.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }
    function selected() {
      return Array.prototype.slice.call(picker.querySelectorAll('[data-opt]')).map(function (group) {
        var active = group.querySelector('.is-active');
        return active ? active.dataset.value : null;
      });
    }
    function update() {
      var chosen = selected();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] && variants[i].options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) { match = variants[i]; break; }
      }
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
      }
    }
    picker.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('[data-opt]');
        group.querySelectorAll('.swatch').forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-pressed', 'false');
        });
        sw.classList.add('is-active');
        sw.setAttribute('aria-pressed', 'true');
        update();
      });
    });
    update();
  }

  document.querySelectorAll('[data-auto-submit]').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });
})();
